import { toast } from 'sonner';

/**
 * Unified toast utility replacing both notistack's enqueueSnackbar
 * and the custom snackbarStore's handleCallToSnack.
 *
 * @param {'success'|'error'|'warning'|'info'|'default'|'danger'} type
 * @param {string|{message: string, title?: string}} messageOrProps
 */
export function showToast(type, messageOrProps) {
  const message =
    typeof messageOrProps === 'string'
      ? messageOrProps
      : messageOrProps?.message;
  const title =
    typeof messageOrProps === 'object' ? messageOrProps?.title : undefined;

  const options = title ? { description: title } : {};

  switch (type) {
    case 'success':
      toast.success(message, options);
      break;
    case 'error':
    case 'danger':
      toast.error(message, options);
      break;
    case 'warning':
      toast.warning(message, options);
      break;
    case 'info':
      toast.info(message, options);
      break;
    default:
      toast(message, options);
      break;
  }
}

/**
 * Drop-in replacement for notistack's enqueueSnackbar.
 * Usage: enqueueSnackbar('message', { variant: 'success' })
 */
export function showToastFromSnackbar(message, options = {}) {
  showToast(options.variant || 'default', message);
}
